import { useProfileContext } from '@/contexts/profile-context';

export const useProfile = () => {
  const { profile, profileStrength, isLoading, error, refreshProfile, updateProfile, shouldShowCompletionDialog, setShouldShowCompletionDialog, dismissCompletionDialog, fetchProfile } = useProfileContext();
  
  return {
    profile,
    profileStrength,
    isLoading,
    error,
    refreshProfile,
    updateProfile,
    shouldShowCompletionDialog,
    setShouldShowCompletionDialog,
    dismissCompletionDialog,
    fetchProfile,
  };
};
